import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'underscore';
import moment from 'moment';
import { makeStyles } from '@mui/styles';

import { DataTable } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	}
}));

const DumpsDataTable = (props) => {
	const { className, data, ...rest } = props;
	const classes = useStyles();

	const _getTableColumns = () => (
		[
			{
				name: 'dumpFile',
				label: 'Dump File',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'vendor',
				label: 'Vendor',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'timeStamp',
				label: 'Last Import',
				options: {
					display: true,
					filterType: 'textField',
					customBodyRender: (value, tableMeta, updateValue) => <>{moment(value).format('DD-MM-YYYY HH:mm:ss').toString()}</>
				}
			}
		]
	);
	const _getTableOptions = () => ({
		filter: false,
		selectableRows: false,
		expandableRows: false, // Try Adding This
	});
	return (
		<div {...rest} className={clsx(classes.container, className)}>
			<DataTable
				id="dumpsDataTable"
				title="Last data import info"
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyMaxHeight="30em"
				tableBodyCellMaxWidth="250"
				options={_getTableOptions()}
			/>
		</div>
	);
};

DumpsDataTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default DumpsDataTable;
